import React from 'react'

const StrokeShow = props => (
  <svg viewBox='0 0 100 100' {...props}>
    <g transform="translate(0.000000,100.000000) scale(0.100000,-0.100000)" >
      <path d="M343 936 c-35 -7 -71 -20 -81 -29 -10 -9 -23 -17 -28 -17 -11 0 -94 -77 -94 -87 0 -3 -6 -14 -14 -22 -21 -25 -56 -137 -56 -181 0 -75 51 -193 105 -245 22 -22 84 -65 93 -65 5 0 23 -7 40 -16 57 -28 133 -29 211 -4 39 12 76 29 82 37 10 12 34 -8 144 -117 120 -120 134 -131 153 -121 12 6 27 21 33 33 10 19 -1 33 -116 148 l-126 127 21 39 c12 21 26 44 30 49 4 6 12 39 18 74 29 193 -85 362 -268 398 -76 14 -68 14 -147 -1z m192 -67 c110 -49 175 -148 175 -268 0 -71 -28 -157 -56 -174 -8 -4 -14 -14 -14 -20 0 -7 -25 -29 -55 -49 -176 -116 -424 -12 -451 189 -11 86 3 155 44 218 20 30 42 55 49 55 6 0 16 6 20 14 4 7 28 23 53 34 63 29 171 29 235 1z"/>
    </g>
  </svg>
)

export default StrokeShow;
